<form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <div class="format-select" *ngFor="let types of this.fileTypes; let i = index">
        <input type="checkbox"  kendoCheckBox name="typeGroup" formControlName="{{types}}"/>
        <label class="k-label">
          {{types}}
        </label>
          <input  *ngIf="this.options[i] === 'Formatted'" type="checkbox" [checked]="checked[i]" kendoCheckBox name="i" formControlName="{{options[i]}}"/>
          <label *ngIf="this.options[i] === 'Formatted'" class="k-label">
            {{options[i]}}
          </label>
        <input  *ngIf="this.options[i+1] === 'Pipe Delim'" type="checkbox" [checked]="checked[i+1]" kendoCheckBox name="i" formControlName="{{options[i+1]}}"/>
        <label *ngIf="this.options[i+1] === 'Pipe Delim'" class="k-label">
          {{options[i+1]}}
        </label>
      </div>
</form>

